import React, { Component } from "react";
import {
  Divider,
  Container,
  Loader,
  Dimmer,
  Segment,
  Label,
  Button,
  Icon,
  Message,
} from "semantic-ui-react";

//Components
import Topo from "../../../components/Topo";
import TopoEmpresa from "../../../components/TopoEmpresa";
import FooterEmpresa from "../../../components/FooterEmpresa";
import Footer from "../../../components/Footer";
import { toast } from "react-toastify";
import CardComponent from "../../../components/cards";
//Styles
import "../../../assets/css/certificados.css";

//Utils
import copy from "copy-to-clipboard";
import $ from "jquery";

import { getUSER, getToken, isAuthenticated } from "../../../services/auth";
import { getUserNode } from "../../../services/auth_node";
import { verify_mobile, limpaTituloCurso } from "../../../utils/Utils";
import { producaov2 } from "../../../services/apis";
import swal from "sweetalert";

class Certificados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certificados: 0,
      id: 0,
      cursoAtivo: {
        curso: {
          cover: null,
          icone: null,
          id_curso: null,
          titulo: null,
        },
        uri: null,
      },
      naoCarregou: 0,
      carregando: 1,
      cert_empty: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.copyClick = this.copyClick.bind(this);
    // this.printClick = this.printClick.bind(this);
    this.downloadClick = this.downloadClick.bind(this);
    this.facebookClick = this.facebookClick.bind(this);
    this.renderCard = this.renderCard.bind(this);
  }

  componentDidMount() {
    document.title = "Certificados - Grupo Voitto";

    if (!isAuthenticated()) {
      localStorage.setItem("redirect", `/online/certificados`);
      window.location.href = "/login?redirect=/online/certificados/";
    }

    const id = getUSER().id;
    if (id == 0) {
      producaov2.get("empresa/pessoas/by-token/" + getToken()).then((res) => {
        res = res.data;
        this.handleCertificado(res[0][0].id);
      });
      return;
    }

    this.handleCertificado(id);
  }

  handleCertificado(id) {
    this.setState({ id }, () =>
      producaov2
        .post(`certificados`, { id_aluno: this.state.id })
        .then((res) => {
          const data = this.certificado_repetido(res.data);
          const certificados = data.map((v) => {
            return v.curso;
          });
          this.setState({ certificados });
          this.setState({ carregando: 0 });
          if (this.props.match.params.id !== undefined) {
            this.handleClickWithParam(this.props.match.params.id);
          }
        })
        .catch((v) => {
          this.setState({ carregando: 0, cert_empty: true });
        })
    );
  }

  naoCarregou() {
    this.setState({ carregando: 0, naoCarregou: 1 });
    //toast.info('Geração de certificado em andamento, aguarde 1 minuto e volte para ver sua conquista!', { position: "bottom-center",autoClose: 10000, hideProgressBar: true, closeOnClick: true, pauseOnHover: false, draggable: true, className: "toast-copiado"});
    // setTimeout(()=>window.location.href="/online/certificados", 40000);
  }

  certificado_repetido(certificates) {
    let filteredCertificates = [];
    (certificates || []).forEach((certificate) => {
      if (
        !filteredCertificates.some(
          (item) => item.curso.curso === certificate.curso.curso
        )
      ) {
        filteredCertificates.push(certificate);
      }
    });
    return filteredCertificates;
  }

  handleClickWithParam(cardProps) {
    var idCurso = cardProps;
    this.setState({ carregando: 1 });
    producaov2.post("admin/certificate", {
      userId: this.state.id,
      courseId: idCurso,
    })
    .then((v) => {
      var certificado = {};
      certificado.uri = v.data.url;
      certificado.curso = "";

      var certificados = this.state.certificados;
      certificados.push(certificado);

      this.setState({ cursoAtivo: certificado, carregando: 0 }, async () => {
        if (v.data.novo) {
          this.setState({ certificados });
          if (!getUserNode().empresa) {
            producaov2.post("/certificado/email", {
              id_aluno: this.state.id,
              id_curso: idCurso,
            });
            producaov2.post("/bank/voittocoins", {
              type: 2,
              userId: this.state.id,
              tracking: idCurso,
            });
            swal(
              "Certificado gerado!",
              "Parabéns! Seu certificado está pronto e você conquistou 100 VoittoCoins!",
              "success"
            );
            await producaov2.post("/rd/finalizacao", {
              id_curso: idCurso,
              id_pessoa: this.state.id,
            });
          }
        }
      });
    })
    .catch((v) => {
      swal(
        "Ops, ocorreu um erro!",
        "Não foi possível gerar esse ceritifcado, se o erro persistir entre em contato conosco.",
        "error"
      );
      this.setState({ carregando: 0 });
    });
  }

  handleClick = (cardProps) => {
    var idCurso = cardProps;
    for (let i = 0; i < this.state.certificados.length; i++) {
      if (this.state.certificados[i].id === idCurso) {
        this.setState({ carregando: 1 });
        producaov2.post("admin/certificate", {
            userId: this.state.id,
            courseId: idCurso,
          })
          .then((v) => {
            this.state.certificados[i].uri = v.data.url;
            this.state.certificados[i].curso = limpaTituloCurso(
              this.state.certificados[i].curso !== undefined
                ? this.state.certificados[i].curso
                : this.state.certificados[i].titulo
            );
            this.setState(
              { cursoAtivo: this.state.certificados[i], carregando: 0 },
              () => {
                if (v.data.novo && !getUserNode().empresa) {
                  producaov2.post("/certificado/email", {
                    id_aluno: this.state.id,
                    id_curso: idCurso,
                  });
                  producaov2.post("/bank/voittocoins", {
                    type: 2,
                    userId: this.state.id,
                    tracking: idCurso,
                  });
                  swal(
                    "Certifcado gerado!",
                    "Parabéns! Seu certificado está pronto e você conquistou 100 VoittoCoins!",
                    "success"
                  );
                }
              }
            );
          })
          .catch((v) => {
            this.setState({ carregando: 0 });
          });
      }
    }

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  };

  copyClick() {
    copy(this.state.cursoAtivo.uri);
    toast("Link Copiado!", {
      position: "bottom-center",
      autoClose: 2500,
      closeOnClick: true,
      pauseOnHover: false,
      hideProgressBar: false,
      className: "toast-copiado",
    });
  }

  downloadClick() {
    var a = document.createElement("a");
    a.setAttribute(
      "download",
      "Certificado " + this.state.cursoAtivo.curso + ".pdf"
    );
    a.setAttribute("href", this.state.cursoAtivo.uri);
    a.setAttribute("target", "_blank");
    a.click();
    a = null;
  }

  facebookClick() {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${this.state.cursoAtivo.uri}`
    );
  }

  linkedinClick() {
    window.open(
      "https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME",
      "_blank"
    );
  }

  returnCover(link) {
    // let src = link.split('capas/')[1];
    return `https://files.voitto.com.br/cursos/small/${link}.jpg`;
  }

  imgBroken(ev) {
    ev.target.src =
      "https://files.voitto.com.br/ftp-files/assets/images/no-image.jpg";
  }
  openUrl(uri) {
    window.open(uri, "_blank");
  }
  renderCard(card) {
    return <div></div>;
  }

  renderCardNew(card) {
    return (
      <CardComponent
        imagem={this.returnCover(card.url_amigavel)}
        identificator={card.id}
        renderPreview={this.handleClick.bind(this)}
        titulo={limpaTituloCurso(
          card.curso !== undefined ? card.curso : card.titulo
        )}
        imageError={this.imgBroken.bind(this)}
      />
    );
  }
  render() {
    return (
      <div>
        {getUserNode().alunoEmpresa &&
        getUserNode().empresa &&
        getUserNode().empresa.id !== 10705 ? (
          <TopoEmpresa />
        ) : (
          <Topo />
        )}
        {this.state.carregando === 0 || this.state.naoCarregou == 1 ? null : (
          <Dimmer style={{ zIndex: "10000000" }} active />
        )}

        <Container fluid>
          <Container fluid>
            <Container
              style={
                verify_mobile()
                  ? styles.containerInteriorMobile
                  : styles.containerInterior
              }
            >
              <h1
                style={{
                  margin: "25px auto 50px auto",
                  width: "max-content",
                  letterSpacing: "0.01rem",
                }}
              >
                Meus Certificados
              </h1>

              {this.state.cursoAtivo.uri !== null && (
                <Container
                  className="containerTituloCertificado"
                  style={{ marginBottom: "2%" }}
                >
                  {verify_mobile() ? (
                    <Segment id="certificado-e-titulo">
                      {verify_mobile() ? (
                        <t
                          style={{
                            marginBottom: "1vh",
                            fontFamily: "Montserrat",
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                          id="actual-titulo"
                        >
                          {this.state.cursoAtivo.curso}
                        </t>
                      ) : (
                        <Label as="a" color="white" ribbon>
                          <span
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "18px",
                              color: "rgba(0, 0, 0, 0.6)",
                            }}
                            id="actual-titulo"
                          >
                            {this.state.cursoAtivo.curso}
                          </span>
                        </Label>
                      )}
                      <div id="botoes-certificado" style={{ maginTop: "7vh" }}>
                        <Button
                          onClick={this.linkedinClick}
                          color="linkedin"
                          floated="right"
                        >
                          <Icon name="linkedin" /> LinkedIn
                        </Button>
                        <Button
                          onClick={this.facebookClick}
                          color="facebook"
                          floated="right"
                        >
                          <Icon name="facebook" /> Facebook
                        </Button>
                        <Button
                          onClick={() =>
                            this.openUrl(this.state.cursoAtivo.uri)
                          }
                          floated="right"
                        >
                          <Icon class="download icon" name="download" />
                          Download
                        </Button>
                        <Button
                          onClick={this.copyClick}
                          className="ui orange left floated button"
                          floated="left"
                        >
                          <Icon name="copy outline" />
                          Copiar URL do certificado
                        </Button>
                      </div>
                    </Segment>
                  ) : (
                    <div>
                      <Segment id="certificado-e-titulo">
                        {verify_mobile() ? (
                          <t
                            style={{
                              marginBottom: "1vh",
                              fontFamily: "Montserrat",
                              fontSize: "18px",
                              fontWeight: "700",
                              color: "rgba(0, 0, 0, 0.6)",
                            }}
                            id="actual-titulo"
                          >
                            {this.state.cursoAtivo.curso}
                          </t>
                        ) : (
                          <Label as="a" color="white" ribbon>
                            <span
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "18px",
                                color: "rgba(0, 0, 0, 0.6)",
                              }}
                              id="actual-titulo"
                            >
                              {this.state.cursoAtivo.curso}
                            </span>
                          </Label>
                        )}
                        <iframe
                          type="application/pdf"
                          frameborder="0"
                          class="ui container"
                          width="100%"
                          height="400"
                          id="certificado"
                          src={this.state.cursoAtivo.uri}
                        ></iframe>
                      </Segment>

                      <div
                        id="botoes-certificado"
                        style={{ marginBottom: "10vh" }}
                      >
                        <Button
                          onClick={this.linkedinClick}
                          style={{ backgroundColor: "#147AB0" }}
                          floated="right"
                        >
                          <Icon style={{ color: "white" }} name="linkedin" />
                          <t style={{ color: "white" }}>
                            Adicionar ao Linkedin
                          </t>
                        </Button>
                        <Button
                          onClick={this.facebookClick}
                          style={{ backgroundColor: "#304D89" }}
                          floated="right"
                        >
                          <Icon style={{ color: "white" }} name="facebook" />
                          <t style={{ color: "white" }}>Compartilhar</t>
                        </Button>

                        <Button
                          onClick={this.copyClick}
                          className="ui orange left floated button"
                          floated="left"
                        >
                          <Icon name="copy outline" />
                          Copiar URL do certificado
                        </Button>
                        <Button
                          icon
                          onClick={this.downloadClick}
                          style={{ backgroundColor: "#21ba45" }}
                          floated="left"
                        >
                          <Icon
                            style={{ color: "white" }}
                            className="icone-unico"
                            name="save"
                          />
                        </Button>
                      </div>
                    </div>
                  )}
                </Container>
              )}

              {(this.state.certificados.length === 0 ||
                this.state.cert_empty) && (
                <div>
                  <Message>
                    <Message.Header className="mensagem-sem-certificado">
                      Infelizmente, não encontramos nenhum certificado em seu
                      perfil!
                    </Message.Header>
                  </Message>
                </div>
              )}

              {this.state.naoCarregou === 1 && (
                <div>
                  <Message>
                    <Message.Header className="mensagem-sem-certificado">
                      Geração de certificado em andamento, aguarde 1 minuto e
                      volte para ver sua nova conquista!
                    </Message.Header>
                  </Message>
                </div>
              )}

              {verify_mobile() ? (
                <div>
                  {this.state.carregando === 0 &&
                  this.state.naoCarregou === 0 &&
                  !this.state.cert_empty ? (
                    this.state.certificados.map((card) =>
                      this.renderCardNew(card)
                    )
                  ) : this.state.naoCarregou === 1 ||
                    !this.state.cert_empty ? null : (
                    <Loader
                      style={{ zIndex: "10000001" }}
                      size="massive"
                      active
                      inline="centered"
                    >
                      <t style={{ color: "#fff", zIndex: "10000002" }}>
                        Gerando seus Certificados
                      </t>
                      <br />
                      <p
                        style={{
                          color: "#fff",
                          fontSize: "14px",
                          marginTop: "6px",
                          zIndex: "10000002",
                        }}
                      >
                        Estamos homologando seu certificado e em alguns minutos
                        ele estará disponível nesta página.
                        <br />
                        Para sua comodidade enviamos um aviso também por seu
                        e-mail cadastrado
                      </p>
                    </Loader>
                  )}
                </div>
              ) : (
                <div
                  className=" row"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {this.state.carregando === 0 &&
                  this.state.naoCarregou === 0 &&
                  !this.state.cert_empty
                    ? this.state.certificados.map((card) =>
                        this.renderCardNew(card)
                      )
                    : this.state.naoCarregou !== 1 &&
                      this.state.cert_empty == false && (
                        <Loader
                          style={{ zIndex: "10000001" }}
                          size="massive"
                          active
                          inline="centered"
                        >
                          <t style={{ color: "#fff", zIndex: "10000002" }}>
                            Gerando seus Certificados
                          </t>
                          <br />
                          <p
                            style={{
                              color: "#fff",
                              fontSize: "14px",
                              marginTop: "6px",
                              zIndex: "10000002",
                            }}
                          >
                            Estamos homologando seu certificado e em alguns
                            minutos ele estará disponível nesta página.
                            <br />
                            Para sua comodidade enviamos um aviso também por seu
                            e-mail cadastrado
                          </p>
                        </Loader>
                      )}
                </div>
              )}
            </Container>
            {(this.state.certificados.length === 0 ||
              this.state.certificados === 0 ||
              this.state.naoCarregou === 1) &&
            !verify_mobile() ? (
              <div>
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
                <Divider hidden />
              </div>
            ) : null}

            {getUserNode().alunoEmpresa &&
            getUserNode().empresa &&
            getUserNode().empresa.id !== 10705 ? (
              <FooterEmpresa />
            ) : (
              <Footer />
            )}
          </Container>
        </Container>
      </div>
    );
  }
}

var styles = {
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    borderRadius: "0px",
    height: "auto",
    padding: "0px",
  },
  cardMeta: {
    fontSize: "14px",
    fontFamily: "Montserrat",
    color: "#999",
  },

  coluna: {
    width: "100%",
  },
  containerInterior: {
    paddingTop: "15vh",
    minHeight: "calc(90vh - 70px)",
  },
  containerInteriorMobile: {
    paddingTop: "7vh",
    maxHeight: "fit-content",
    marginBottom: "7vh",
  },
};
export default Certificados;
